import BN from "bn.js";

export const MAXIMUM_UNSTAKE_COOLDOWN_SECONDS = new BN(365 * 24 * 3600);
export const MINIMUM_UNSTAKE_COOLDOWN_SECONDS = new BN(24 * 3600);
export const MAX_FEE_BASIS_POINTS = 10_000;
export const MAX_BPS = new BN(MAX_FEE_BASIS_POINTS);
